import React from 'react';
import logoImage from '../logo.png';

const Logo = ({ className = "h-10 w-10" }) => {
  return (
    <img 
      src={logoImage}
      alt="PEXADIA Logo" 
      className={`${className} object-contain`}
      style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
    />
  );
};

export default Logo;

